import { render } from "./ManageServers.vue?vue&type=template&id=587ba3a6"
import script from "./ManageServers.vue?vue&type=script&lang=js"
export * from "./ManageServers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__